/**
 * SeoSchemaHelper - Helper to process SEO schema data
 */
const SeoSchemaHelper = {
    /**
    * This function encapsulates logic to ensure that the schema data
    * is in a valid JSON string format
    *  */
    processSchemaData: function (schemaData) {
        // If schemaData is not a string, convert it using JSON.stringify.
        if(!schemaData){
            return `{ "@context": "http://schema.org" }`
        }
        return typeof schemaData !== 'string' ? JSON.stringify(schemaData) : schemaData;
    },
    /**
    * Generate a SportsEvent schema using dynamic sport event data.
    * @param {Object} sportData - Dynamic sport event data
    * @param {Array} customSchemas - Additional custom schemas to merge
    * @returns {String} - JSON stringified SportsEvent schema
    * */

    generateSportsEventSchema: function (sportData, customSchemas = []) {
        // Build the default SportsEvent schema using dynamic sport event data.
        const schema = {
            "@context": "https://schema.org",
            "@type": "SportsEvent",
            "name": sportData.sportEventName, // Dynamic event name (e.g. "Team A vs Team B")
            "startDate": sportData.sportEventDate, // Dynamic event date (formatted)
            "eventStatus": "https://schema.org/EventScheduled",
            "performer": {
                "@type": "SportsTeam",
                "name": sportData.sportTeam1, // First team name
                "sport": sportData.sportName, // Sport type (e.g. "Basketball")
                "memberOf": {
                    "@type": "SportsOrganization",
                    "name": sportData.sportTournamentName // Tournament/organization name
                }
            },
            "competitor": {
                "@type": "SportsTeam",
                "name": sportData.sportTeam2, // Second team name
                "sport": sportData.sportName, // Same sport type
                "memberOf": {
                    "@type": "SportsOrganization",
                    "name": sportData.sportTournamentName // Same tournament/organization name
                }
            }
        };

        // If additional custom schemas are provided, merge them in an array.
        if (customSchemas && Array.isArray(customSchemas) && customSchemas.length > 0) {
            return JSON.stringify([schema, ...customSchemas]);
        }

        // Otherwise, return the default schema as a JSON string.
        return JSON.stringify(schema);
    }
};

export default SeoSchemaHelper;
